import { Outlet } from '@remix-run/react';

export { ErrorBoundary } from '#app/components/AuthenticatedLayout.js';

export default () => <Outlet />;
